import {
  Checkbox,
  Col,
  Form,
  Input,
  Select,
  Tooltip,
  Typography,
  Radio,
  Row,
  InputNumber,
  AutoComplete,
  Button,
  Switch,
  DatePicker,
  Upload,
} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { FORMAT_TIME } from "types/enums/format-time";
import { AddSVG } from "assets/svg";
import { FIELD_TYPE } from "types/enums/field-type";

dayjs.locale("vi");
const {
  INPUT,
  INPUT_PASSWORD,
  SELECT,
  CHECKBOX,
  RADIO,
  DATE,
  RADIO_BUTTON,
  NUMBER,
  AUTO_COMPLETE,
  TEXT_AREA,
  NORMAL_CHECKBOX,
  NORMAL_CHECKBOX_NONE,
  TEXTT_AREA_CUSTOM,
  INPUT_NUMBER,
  SWITCH,
  UPLOAD,
} = FIELD_TYPE;

const FormItem = (props) => {
  const {
    propsUpload,
    icon,
    placeholder,
    suffix,
    disabled,
    checkbox,
    type,
    options,
    addonAfter,
    radioButtons,
    optionsTime = { showTime: false, format: FORMAT_TIME.dayFull },
    className,
    labelCol,
    wrapperCol,
    rules,
    name,
    label,
    value,
    radioButton,
    onChange,
    onSearch,
    onPressEnter,
    statusDrug,
    defaultValue,
    onSelect,
    radioCustom,
    disableDate = true,
    disabledDate,
    valuePropName,
    mode,
    filterOption,
    initialValue = null,
    allowClear = true,
    changeOnBlur,
    onOpenChange,
    formatter,
    onClick,
    btn = false,
    ...rest
  } = props;
  const renderFormItem = () => {
    switch (type) {
      case INPUT:
        return (
          <Input
            style={{
              width: "100%",
            }}
            value={value ?? null}
            placeholder={!disabled ? placeholder ?? "Nhập" : "--"}
            suffix={suffix}
            disabled={disabled}
            addonAfter={addonAfter}
            allowClear
            {...rest}
            autoComplete="off"
          />
        );

      case INPUT_NUMBER:
        return (
          <InputNumber
            style={{
              width: "100%",
            }}
            suffix={suffix}
            disabled={disabled}
            addonAfter={addonAfter}
            allowClear
            controls={false}
            onChange={onChange}
            type="number"
            {...rest}
          />
        );
      case INPUT_PASSWORD:
        return (
          <Input.Password
            placeholder="Nhập mật khẩu"
            allowClear
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
            autoComplete="off"
            {...rest}
          />
        );
      case TEXT_AREA:
        return (
          <Input.TextArea
            value={value ?? null}
            placeholder={!disabled ? placeholder ?? "Nhập" : "--"}
            allowClear
            onChange={onChange}
            disabled={disabled}
            autoSize
            rows={1}
            {...rest}
          />
        );

      case SELECT:
        return (
          <Select
            mode={mode}
            showSearch
            style={{
              width: "100%",
            }}
            filterOption={(input, option) =>
              (option?.label?.toString().toLowerCase() ?? "").includes(
                input.toLowerCase()
              )
            }
            defaultValue={defaultValue ?? null}
            placeholder={!disabled ? placeholder ?? "Chọn" : "--"}
            options={options}
            disabled={disabled}
            allowClear={allowClear}
            onChange={onChange}
            {...rest}
          />
        );

      case CHECKBOX:
        return (
          <Checkbox.Group disabled={disabled} onChange={onChange}>
            <Row>
              {checkbox?.map((item, index) => (
                <Col key={index} span={item.span}>
                  <Checkbox
                    value={item.value}
                    style={{
                      width: "100%",
                    }}
                  >
                    {item.label}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        );
      case DATE:
        return (
          <DatePicker
            style={{
              width: "100%",
            }}
            disabled={disabled}
            format={optionsTime.format}
            showTime={optionsTime.format === FORMAT_TIME.dateTime}
            disabledDate={
              disableDate
                ? (current) => {
                    return current.isAfter(dayjs());
                  }
                : false
            }
            placeholder={
              !disabled ? optionsTime.format ?? placeholder ?? "Chọn" : "--"
            }
            onChange={onChange}
            allowClear
            changeOnBlur={changeOnBlur}
            {...rest}
          />
        );
      case NORMAL_CHECKBOX:
        return (
          <Checkbox
            value={value}
            style={{
              width: "100%",
            }}
            defaultChecked={false}
            disabled={disabled}
          ></Checkbox>
        );
      case NORMAL_CHECKBOX_NONE:
        return (
          <Checkbox
            value={value}
            style={{
              width: "100%",
            }}
            defaultChecked={false}
            disabled={disabled}
            onChange={onChange}
          ></Checkbox>
        );

      case RADIO:
        return (
          <Radio.Group value={true} disabled={disabled} onChange={onChange}>
            {options ? (
              <Row
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                {options.map((e) => {
                  return <Radio value={e?.value}>{e?.label}</Radio>;
                })}
              </Row>
            ) : (
              <>
                {" "}
                <Radio value={true}>Có</Radio>
                <Radio value={false}>Không</Radio>
              </>
            )}
          </Radio.Group>
        );
      case RADIO_BUTTON:
        return (
          <Radio.Group
            style={{ width: "100%" }}
            size="middle"
            buttonStyle="solid"
            disabled={disabled}
            onChange={onChange}
          >
            <Row justify={"center"}>
              {radioButtons?.map((item, index) => {
                if (item.span) {
                  return (
                    <Col span={item.span} key={index}>
                      <Tooltip title={item.label}>
                        <Radio.Button
                          className="button-radio"
                          value={item.value}
                        >
                          {item.label}
                        </Radio.Button>
                      </Tooltip>
                    </Col>
                  );
                } else
                  return (
                    <Col flex={1} key={index}>
                      <Tooltip title={item.label}>
                        <Radio.Button
                          className="button-radio"
                          value={item.value}
                        >
                          {item.label}
                        </Radio.Button>
                      </Tooltip>
                    </Col>
                  );
              })}
            </Row>
          </Radio.Group>
        );

      case NUMBER:
        return (
          <InputNumber
            style={{ width: "100%" }}
            placeholder={!disabled ? placeholder ?? "Nhập" : "--"}
            disabled={disabled}
            value={value}
            addonAfter={addonAfter}
            defaultValue={value}
            controls={false}
            onChange={onChange}
            {...rest}
          ></InputNumber>
        );
      case AUTO_COMPLETE:
        return (
          <AutoComplete
            showSearch
            allowClear
            placeholder={!disabled ? placeholder ?? "Chọn" : "--"}
            notFoundContent={null}
            value={value}
            onSelect={onSelect}
            defaultActiveFirstOption={false}
            filterOption={
              filterOption
                ? filterOption
                : (inputValue, option) =>
                    option!.label
                      ?.toString()
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
            }
            options={options}
            disabled={disabled}
            onChange={onChange}
            onSearch={onSearch}
            {...rest}
          ></AutoComplete>
        );

      case TEXTT_AREA_CUSTOM:
        return <textarea value={value} onChange={onChange} />;
      case SWITCH:
        return <Switch defaultChecked />;

      case UPLOAD:
        return (
          <Upload {...propsUpload} showUploadList={false}>
            <Button icon={icon}>Tải file lên</Button>
          </Upload>
        );

      default:
        break;
    }
  };
  return (
    <Form.Item
      className={className}
      rules={rules}
      labelCol={{
        xs: labelCol.xs,
        sm: labelCol.sm,
        md: labelCol.md,
        lg: labelCol.lg,
        xl: labelCol.xl,
      }}
      wrapperCol={{
        xs: wrapperCol.xs,
        sm: wrapperCol.sm,
        md: wrapperCol.md,
        lg: wrapperCol.lg,
        xl: wrapperCol.xl,
      }}
      initialValue={initialValue}
      key={name}
      label={
        label ? (
          <>
            {btn && (
              <Button
                type="text"
                id="btn-add-group"
                icon={<AddSVG />}
                onClick={() => {
                  onClick();
                }}
              />
            )}

            <Tooltip placement="bottom" arrow={false} title={label}>
              <Typography.Text
                className="form-item-text"
                style={{
                  // whiteSpace: "pre-wrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  marginRight: "5px",
                }}
              >
                {label}
              </Typography.Text>
            </Tooltip>
          </>
        ) : (
          ""
        )
      }
      valuePropName={valuePropName}
      name={name}
    >
      {renderFormItem()}
    </Form.Item>
  );
};

export default FormItem;
